<template>
  <div class="modal-docs">
    <button class="btn-regular primary" @click.stop="toggleModal">Open Modal</button>
    <button class="btn-regular primary" @click.stop="toggleModal('small')">Open Modal Small</button>
    <div class="modal-docs__buttons">
      <button class="btn-regular primary" @click.stop="toggleModal('popup')">Open Modal 480</button>
      <button class="btn-regular primary" @click.stop="toggleModal('medium')">Open Modal Medium</button>
      <button class="btn-regular primary" @click.stop="toggleModal('large')">Open Modal Large</button>
    </div>
    <modal v-if="isOpen" @modal-close="toggleModal" :type="type">
      <div slot="content" class="content">
        asd
      </div>
    </modal>
  </div>
</template>

<script>
import Modal from '@/components/Modal'
import Media from 'vue-media';

export default {
  name: 'adx-modal-docs',
  components: {
    'modal': Modal,
    'media': Media
  },
  data(){
    return {
      isOpen: false,
      type: ''
    }
  },
  methods: {
    toggleModal(type){
      this.type = ''
      if (type) {
        this.type = type
      } 
      this.isOpen = !this.isOpen;
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>